import * as React from "react";
import { BlogCard } from "./BlogCard";
import { Button } from "./Button";
import { Flex, Grid } from "@radix-ui/themes";

export function BlogPostList({category, preview, posts}) {

    const categoryFilter = (blog) => {
        if (category) {
            return blog.category === category;
        } else {
            return true;
        }
    };


    return <>
        <Flex direction="column" gap="6" mt="3" mb="6">
            <Grid columns="3" gap="6" className="grid-resizable">
                {
                    posts && posts.filter(categoryFilter).map((post, index) => {
                        if (!preview) {
                            return <BlogCard key={index} blog={post} />;
                        }
                        if (preview && index < 3) {
                            return <BlogCard key={index} blog={post}/>;
                        }
                    })
                }
            </Grid>
            {preview && <Button href={`/blog/category/${category}/`}>View All</Button>}
        </Flex>
    </>;
}

